import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { ZagIcon } from '../icon';

@Component({
  selector: 'zag-group-divider',
  templateUrl: './group-divider.component.html',
  styleUrl: './group-divider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, ZagIcon],
  host: { '[attr.role]': 'collapsible() ? null : "separator"' },
})
export class GroupDividerComponent {
  readonly label = input.required<string>();
  readonly count = input<number | null>(null);
  readonly icon = input<string | null>(null);
  readonly collapsible = input(false);
  readonly expanded = model(true);
  readonly controls = input<string | null>(null);
}
